export const PROTECANCER_AMOUNTS: {title: string, value: number, selected: boolean}[] = [
  {title: '$ 300,000', value: 300000, selected: true},
  {title: '$ 400,000', value: 400000, selected: false},
  {title: '$ 500,000', value: 500000, selected: false}
];
